import React from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "./Checkbox";

const CheckboxGroup = ({ label, options }) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup>
        {options.map(option => (
          <Checkbox key={option.value} {...option} />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default React.memo(CheckboxGroup);
